// @ts-nocheck
import type { Question } from '../types';
import { roundaboutRulesMultilingual } from './translations/roundaboutRulesTranslations';

/** Public bucket — filenames must match objects in `roundabout-rules` (image URLs only). */
const RR_IMG =
  'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/roundabout-rules';

/** One image per listed asset; IDs align with multilingual copy so EN / NL / AR stay consistent. */
const ROUNDABOUT_IMAGE_BY_ID: Record<string, string> = {
  'q-rr-2': `${RR_IMG}/q-rr-2-exit-signal.jpg`,
  'q-rr-3': `${RR_IMG}/q3-left-turn-roundabout.jpg`,
  'q-rr-4': `${RR_IMG}/q4-straight-roundabout.jpg`,
  'q-rr-5': `${RR_IMG}/q5-right-turn-roundabout.jpg`,
  'q-rr-8': `${RR_IMG}/q8-pedestrian-exit.jpg`,
  'q-rr-9': `${RR_IMG}/q-rr-9-emergency-vehicle.jpg`,
  'q-rr-10': `${RR_IMG}/q-rr-10-u-turn.jpg`,
  'q-rr-14': `${RR_IMG}/q14-cyclist-exit-lane.jpg`,
  'q-rr-17': `${RR_IMG}/q17-third-exit-roundabout.jpg`,
  'q-rr-20': `${RR_IMG}/q20-multiple-lanes-exit.jpg`,
};

export const roundaboutRulesQuestions: Question[] = roundaboutRulesMultilingual.map(mq => {
  const imageUrl = ROUNDABOUT_IMAGE_BY_ID[mq.id];
  return {
    id: mq.id,
    topic: 'General',
    question: mq.text.en,
    text: mq.text.en,
    options: mq.options.map(opt => ({
      id: opt.id,
      text: opt.text.en,
    })),
    answerId: mq.correctAnswerId,
    correctAnswerId: mq.correctAnswerId,
    explanation: mq.explanation.en,
    subject: mq.subject,
    ...(imageUrl ? { imageUrl } : {}),
    ...(mq.questionType ? { questionType: mq.questionType } : {}),
    ...(mq.yesNoMapping ? { yesNoMapping: mq.yesNoMapping } : {}),
  };
});
